import Select from '../../common/Select';
import { connect } from 'react-redux';
import { matrixBlur, matrixDropdownChange } from './actions';
import { questionKey } from '../response/reducer';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  const values = question.rows[ownProps.rowIndex].values;
  const value = Array.isArray(values) ? values[0] || '' : values;
  return { value };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e =>
    dispatch(
      matrixDropdownChange(
        e.target.value,
        ownProps.rowIndex,
        ownProps.questionId
      )
    ),
  onBlur: () => dispatch(matrixBlur(ownProps.rowIndex, ownProps.questionId)),
});

const MatrixDropdown = connect(mapStateToProps, mapDispatchToProps)(Select);

export default MatrixDropdown;
